import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSeismicsSizeS from './IconSeismics_size_s';

const props: CreateIconArguments = {
  l: IconSeismicsSizeS,
  m: IconSeismicsSizeS,
  s: IconSeismicsSizeS,
  xs: IconSeismicsSizeS,
  name: 'IconSeismics',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
